import { DISPLAY_CONTEXT } from './constants';

const ACTION = {
  UPDATE_ALL_DATA: 'UPDATE_ALL_DATA',
  UPDATE_DISPLAY_CONTEXT: 'UPDATE_DISPLAY_CONTEXT',
  UPDATE_DISPLAY_PAYMENT_GATEWAY: 'UPDATE_DISPLAY_PAYMENT_GATEWAY',
  UPDATE_RESPONSE_DATA: 'UPDATE_RESPONSE_DATA',
};

const INIT_STATE = {
  displayPaymentGateway: false,
  isPremiumMidfunnelPayment: false,
  displayContext: DISPLAY_CONTEXT.MODULAR_LISTING,
  isResponseSuccess: false,
  responseData: {},
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION.UPDATE_DISPLAY_PAYMENT_GATEWAY: {
      const { displayPaymentGateway, isPremiumMidfunnelPayment } = payload;

      return {
        ...state,
        isResponseSuccess: false,
        displayPaymentGateway,
        isPremiumMidfunnelPayment,
        // TODO: ask 'johna' why there is this logic to set to 'null' - (phyoh)
        displayContext: displayPaymentGateway ? state.displayContext : null,
      };
    }
    case ACTION.UPDATE_DISPLAY_CONTEXT: {
      const { displayContext } = payload;

      return {
        ...state,
        displayContext,
      };
    }
    case ACTION.UPDATE_RESPONSE_DATA: {
      const { responseData, isResponseSuccess = false } = payload;

      return {
        ...state,
        isResponseSuccess,
        responseData,
      };
    }

    case ACTION.UPDATE_ALL_DATA: {
      const { data } = payload;

      return {
        ...state,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};

export { ACTION, INIT_STATE };

export default reducer;
